import { useEffect } from "react";
import HolzfinderSelect, { HolzfinderSelectProps } from "./HolzfinderSelect";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  getTaxationKinds,
  selectTaxationKinds,
} from "features/taxationKinds/taxationKindsSlice";

enum TaxTypes {
  "R" = "regelbesteuert",
  "P" = "pauschalbesteuert",
  "K" = "Kleinunternehmer",
  "F" = "land-/forstwirtschaftl. Betr.",
}
export function HolzfinderTaxSelect(
  props: Omit<
    HolzfinderSelectProps,
    "id" | "label" | "options" | "currentValue" | "defaultValue"
  >
) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    // get Options from API
    dispatch(getTaxationKinds());
  }, [dispatch]);
  const taxationKinds = useAppSelector(selectTaxationKinds) || [];
  const { value, onChange } = props;
  return (
    <HolzfinderSelect
      sx={{ width: "100%" }}
      {...props}
      id="tax_type"
      label="Besteuerungstyp"
      options={taxationKinds.map((kind) => ({
        value: kind.id,
        label: `${kind.short_name} - ${kind.name}`,
      }))}
      currentValue={(value || TaxTypes.R) as string}
      defaultValue={TaxTypes.R}
      onChange={onChange}
    />
  );
}
